



















































import Vue from "vue";
import { scopeToggleState } from "@tt-app/utils";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import IconDictionary from "@joyz/app-core/assets/icons/default/Dictionary.svg";
import IconEnglish from "@joyz/app-core/assets/icons/default/English.svg";
import IconEnglishHide from "@joyz/app-core/assets/icons/default/EnglishHide.svg";
import IconTranslation from "@joyz/app-core/assets/icons/default/Translation.svg";
import IconTranslationHide from "@joyz/app-core/assets/icons/default/TranslationHide.svg";
import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";
import IconCheckboxActive from "@joyz/app-core/assets/icons/active/Checkbox.svg";
import IconCheckboxIndeterminate from "@joyz/app-core/assets/icons/active/CheckboxIndeterminate.svg";

import ExerciseScopeItem from "@tt-app/components/exercise/ExerciseScopeItem.vue";
import JzCard from "@joyz/app-core/components/panel/JzCard.vue";

interface Scope {
  audioUrl: string;
  isWord: boolean;
  learnedStatus: number;
  problemUuid: string;
  textEn: string;
  textJa: string;
  wordUuid: string;
}

interface Data {
  icons: {
    [key: string]: string;
  };
  toggleState: number;
}

interface Methods {
  onEnglishToggle: () => void;
  onScopeItemClicked: ({ problemUuid }: { problemUuid: string }) => void;
  onSelectAllClicked: () => void;
  onTranslationToggle: () => void;
}

interface Computed {
  englishToggle: { disabled: boolean; icon: string; text: string };
  selectAllCheckbox: { icon: string; text: string };
  translationToggle: { disabled: boolean; icon: string; text: string };
}

interface Props {
  audioDecoderPlayer: AudioDecoderPlayer;
  disabled: boolean;
  scope: Scope[];
  selectedUuids: string[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ExerciseScope",
  components: {
    ExerciseScopeItem,
    JzCard
  },

  props: {
    audioDecoderPlayer: { type: AudioDecoderPlayer, default: undefined },
    disabled: { type: Boolean, default: false },
    scope: { type: Array, default: () => [] },
    selectedUuids: { type: Array, default: () => [] }
  },

  data() {
    return {
      icons: {
        checkbox: IconCheckbox,
        checkboxActive: IconCheckboxActive,
        checkboxIndeterminate: IconCheckboxIndeterminate,
        dictionary: IconDictionary,
        english: IconEnglish,
        englishHide: IconEnglishHide,
        translation: IconTranslation,
        translationHide: IconTranslationHide
      },
      toggleState: scopeToggleState.none
    };
  },

  methods: {
    onEnglishToggle() {
      if (this.englishToggle.disabled) {
        return;
      }

      this.toggleState =
        this.toggleState === scopeToggleState.none
          ? scopeToggleState.english
          : scopeToggleState.none;
    },

    onScopeItemClicked({ problemUuid }) {
      let updatedUuids;

      if (!this.selectedUuids.includes(problemUuid)) {
        updatedUuids = [...this.selectedUuids, problemUuid];
      } else {
        updatedUuids = this.selectedUuids.filter(selectedUuid => {
          return selectedUuid !== problemUuid;
        });
      }

      this.$emit("selectedUuidsUpdate", updatedUuids);
    },

    onSelectAllClicked() {
      let updatedUuids;

      if (this.selectedUuids.length < this.scope.length) {
        updatedUuids = this.scope.map((question: any) => {
          return question.problemUuid;
        });
      } else {
        updatedUuids = [];
      }

      this.$emit("selectedUuidsUpdate", updatedUuids);
    },

    onTranslationToggle() {
      if (this.translationToggle.disabled) {
        return;
      }

      this.toggleState =
        this.toggleState === scopeToggleState.none
          ? scopeToggleState.translation
          : scopeToggleState.none;
    }
  },

  computed: {
    englishToggle() {
      if (this.toggleState === scopeToggleState.translation) {
        return {
          disabled: true,
          icon: this.icons.englishHide,
          text: "exerciseScope.englishHide"
        };
      }

      const icon =
        this.toggleState === scopeToggleState.english ? this.icons.english : this.icons.englishHide;

      const text =
        this.toggleState === scopeToggleState.english
          ? "exerciseScope.english"
          : "exerciseScope.englishHide";

      return {
        disabled: false,
        icon,
        text
      };
    },

    selectAllCheckbox() {
      if (this.selectedUuids.length === 0) {
        return {
          text: "exerciseScope.selectAll",
          icon: this.icons.checkbox
        };
      }

      if (this.scope.length === this.selectedUuids.length) {
        return {
          text: "exerciseScope.deselectAll",
          icon: this.icons.checkboxActive
        };
      }

      return {
        text: "exerciseScope.selectAll",
        icon: this.icons.checkboxIndeterminate
      };
    },

    translationToggle() {
      if (this.toggleState === scopeToggleState.english) {
        return {
          disabled: true,
          icon: this.icons.translationHide,
          text: "exerciseScope.translationHide"
        };
      }

      const icon =
        this.toggleState === scopeToggleState.translation
          ? this.icons.translation
          : this.icons.translationHide;

      const text =
        this.toggleState === scopeToggleState.translation
          ? "exerciseScope.translation"
          : "exerciseScope.translationHide";

      return {
        disabled: false,
        icon,
        text
      };
    }
  }
});
